export const addPupilNames = (homework, pupils) => {
  return {
    ...homework,
    pupils: homework.pupils.map((pupil) =>
      pupil.name
        ? pupil
        : {
            id: pupil,
            name: `${pupils[pupil].firstName} ${pupils[pupil].lastName}`,
          }
    ),
  };
};
